import { render, staticRenderFns } from "./SanPhamTieuBieu.vue?vue&type=template&id=680d7552&scoped=true&"
import script from "./SanPhamTieuBieu.vue?vue&type=script&lang=js&"
export * from "./SanPhamTieuBieu.vue?vue&type=script&lang=js&"
import style0 from "./SanPhamTieuBieu.vue?vue&type=style&index=0&id=680d7552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d7552",
  null
  
)

export default component.exports